import parse from 'utils/parse';

import InteractiveToy from './assets/InteractiveToy.png';
import Messenger from './assets/Messenger.png';
import PrivateShow from './assets/PrivateShow.png';
import VideoCall from './assets/VideoCall.png';
import VideoPhoto from './assets/VideoPhoto.png';
import i18n from './start-earning.i18n';

const translation = i18n.pages.landing.startEarning.livejasmin;

const makeTestId = (...ids: string[]): string => parse.toTestId('start-earning', ...ids);

const testId = Object.freeze({
  component: makeTestId(),
  carouselNav: makeTestId('carousel-nav'),
});

const slides = [PrivateShow, Messenger, VideoPhoto, VideoCall, InteractiveToy];

const navItems = [
  {
    id: 0,
    label: translation.slides.privateAndVipShows,
  },
  {
    id: 1,
    label: translation.slides.messenger,
  },
  {
    id: 2,
    label: translation.slides.photosAndVideos,
  },
  {
    id: 3,
    label: translation.slides.videoCall,
  },
  {
    id: 4,
    label: translation.slides.interactiveToy,
  },
];

export { slides, testId, navItems };
